export default __webpack_public_path__ + "static/media/jiajun.5fddd48a.jpg";